import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';

import { useNavigate } from 'react-router-dom';
import { Outlet } from 'react-router';
import URLs from '../../pages/URLs';
import { Wrapper } from './Layout.styles';
import { MenuAppBar } from '../MenuAppBar/MenuAppBar';

const ProtectedLayout = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const authState = !!Cookies.get('user_id');
    setIsAuthenticated(authState);
    if (!authState) {
      navigate(URLs.Login);
    }
  }, []);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <Wrapper>
      <MenuAppBar />
      <Outlet />
    </Wrapper>
  );
};

export default ProtectedLayout;
